import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { Client, InfoConnectDisconnectDataOut, CommandStatus } from '../../../../api/api-reference';

@Component({
  selector: 'app-connect-disconnect-information',
  standalone: true,
  imports: [TranslateModule, CommonModule, AngularSvgIconModule],
  templateUrl: './connect-disconnect-information.component.html',
  styleUrl: './connect-disconnect-information.component.scss',
})
export class ConnectDisconnectInformationComponent {
  @Input() connectDisconnectId?: string;
  @Output() close=new EventEmitter<boolean>();

  CommandStatus=CommandStatus;

  connDisconnGet: InfoConnectDisconnectDataOut = new InfoConnectDisconnectDataOut();

  constructor(
      private toastr: ToastrService,
      private client: Client,
    ) {}

  ngOnInit(): void{
    this.getConnectDisconnectById();
  }

  toggleModal() {
      this.close.emit();
    }

  getConnectDisconnectById(){
    this.client.getConnectDisconnect(this.connectDisconnectId!).subscribe({
      next:(response) =>{
        this.connDisconnGet=response;
      },
      error:(err)=>{
        this.toastr.error(err);
        this.close.emit();
      }
    })
  }
}